import React, {Component} from 'react';
import Chart from '../common/chart';

module.exports = React.createClass({
    render: function () {
        var Data = {
            doctorID: this.props.doctorID
        };
        return (
            <div className='row'>
                <div className='col-xs-6'>
                    <h3>Patients</h3>
                    <Chart
                        ChartAjaxUrl='/data/GetDoctorsPatientCountBetweenDates'
                        ChartType="line"
                        Data={Data}
                        ID="chart1"
                        containerId="chart1Container"/>
                </div>
                <div className='col-xs-6'>
                    <h3>Active Patients</h3>
                    <Chart
                        ChartAjaxUrl='/data/GetPatientsBetweenDatesForDoctor'
                        ChartType="line"
                        Data={Data}
                        ID="chart2"
                        containerId="chart2Container"
                        MaxTicks="7"/>
                </div>
            </div>
        )
    }
});


// WEBPACK FOOTER //
// ./modules/doctorSummary/DoctorCharts.jsx